<template>
  <div>
    <vm-table
        ref="vmTable"
        height="64vh"
        :filter.sync="filter"
        module="basic"
        url="baseSoftinfoes"
        @select="selectTest"
        @select-all="selectAll">
      <div slot="toolbar">
        <el-button type="primary" @click="$refs.editEid.open(0)">新建</el-button>
        <!--        <el-button type="danger" @click="deleteIds">批量删除</el-button>-->
        <!--        <el-button type="primary" @click="exportExcel()">导出</el-button>-->
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="程序名">
            <el-input v-model.trim="filter.programNo" clearable/>
          </vm-search>
          <vm-search label="状态">
            <el-select v-model="filter.status" clearable>
              <el-option label="草稿" value="0"/>
              <el-option label="提交" value="1"/>
            </el-select>
          </vm-search>
          <vm-search label="备注">
            <el-input v-model.trim="filter.note" clearable/>
          </vm-search>
          <vm-search label="创建人">
            <el-input v-model.trim="filter.creatorName" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column type="selection" align="center" width="55"/>
      <!--      <el-table-column prop="softNo" align="center" label="软件号"/>-->
      <el-table-column prop="programNo" align="center" label="程序号"/>
      <el-table-column prop="baudRate" align="center" label="波特率(K)" width="80px"/>
      <el-table-column prop="sendId" align="center" label="发送ID(0x)" width="140px"/>
      <el-table-column prop="extFlagName" align="center" label="扩展帧" width="80px"/>
      <el-table-column prop="sendByte" align="center" label="发送内容(0x)" width="180px"/>
      <el-table-column prop="statusName" align="center" label="状态" width="80px"/>
      <el-table-column prop="creatorName" align="center" label="创建人" width="100px"/>
      <el-table-column prop="createTime" align="center" label="创建时间" width="140px"/>
      <el-table-column prop="note" align="center" label="备注"/>
      <el-table-column
          label="操作"
          align="center"
          class-name="vm-table_operate"
          width="160px"
          fixed="right">
        <template slot-scope="scope">
          <el-button :disabled="scope.row.status!=0" type="info" @click="$refs.editEid.open(scope.row)">编辑</el-button>
          <el-button :disabled="scope.row.status!=0" type="danger" @click="oneDelete(scope.row)">删除</el-button>
          <el-button :disabled="scope.row.status!=0" type="danger" @click="submit(scope.row)">提交</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <edit-e-i-d-setting ref="editEid" @save-success="getList(1)"/>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import EditEIDSetting from "./EditEIDSetting";

  export default {
    name: "EIDProSettingList",
    components: {EditEIDSetting, VmTable, VmSearch},
    data() {
      return {
        idList: "",
        exportLoading: false,
        filter: {
          note: "",
          status: "",
          programNo: "",
          creatorName: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      selectTest(selection) {
        this.idList = selection;
      },
      selectAll(selection) {
        this.idList = selection;
      },
      // 单项删除
      oneDelete(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
              .delete("basic", "baseSoftinfoes", row.pkid).then(() => {
            this.getList(-1);
            this.$message.success("删除成功");
          });
        });
      },
      submit(row) {
        this.$confirm("确定提交吗?", "提示", {type: "warning"}).then(() => {
          this.$http
              .post("basic", "baseSoftinfoes/submit/" + row.pkid).then(() => {
            this.getList(-1);
            this.$message.success("提交成功");
          });
        });
      },

      // exportExcel() {
      //   window.open(window.config.basicServerUrl + "posts/export");
      // },
      exportExcel() {
        this.exportLoading = true;
        this.$http
            .exportFile("basic", "posts/export", this.filter)
            .then(res => {
              console.log(res);
              let blob = new Blob([res.data]);
              let fileName = decodeURI(res.headers.filename);
              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                navigator.msSaveBlob(blob, fileName);
              } else {
                let a = document.createElement("a");
                a.href = URL.createObjectURL(blob);
                a.download = fileName;
                a.style.display = "none";
                document.body.appendChild(a);
                a.click();
                URL.revokeObjectURL(a.href);
                document.body.removeChild(a);
              }
              this.exportLoading = false;
            })
            .catch(() => {
              this.exportLoading = false;
            });
      },
    },
  };
</script>

<style scoped>

</style>
